export var colors = {
    primary: '#323e48',
    secondary: '#808080',
    secondaryvarient: '#CCCCCC',
    accent: '#70c497',
    link: '#88d0e5',
    success: '#70c497',
    warning: '#febd3d',
    error: '#e05929',
    background: '#fff',
    surface: '#F2F2F2',
};
